<template>
  <div class="animate-pulse rounded bg-gray-200" :class="[height, width]" />
</template>

<script>
export default {
  name: 'BaseSkeletonBar',
  props: {
    height: {
      type: String,
      required: false,
      default: 'h-4'
    },
    width: {
      type: String,
      required: false,
      default: 'w-full'
    }
  }
}
</script>
